module.exports = __webpack_public_path__ + "static/media/Picture_WaitingLady.5d6006f9.png";